import { render, staticRenderFns } from "./InjuryTypeFilter.vue?vue&type=template&id=548fc7ea&"
import script from "./InjuryTypeFilter.vue?vue&type=script&lang=js&"
export * from "./InjuryTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports